<div class="audio-record" [class.audio-recorded]="recordDataUrl">
  @if (recordDataUrl) {
    <lib-audio-player-v2
      [src]="recordDataUrl"
      (durationInitialized)="audioDurationInitialized($event)">
    </lib-audio-player-v2>
  }

  <div class="audio-wrapper" [class.preview-mode]="previewMode" [class.hidden]="recordDataUrl">
    @if (progress && !recordDataUrl) {
      <div class="audio-record__progress primary-border primary-background-transparent-15" [style.width.%]="progress"></div>
    }
    <audio #audioElement class="video-js vjs-default-skin"></audio>
  </div>

  @if (previewMode) {
    <div class="preview-placeholder">
      <mat-icon class="primary-color">audiotrack</mat-icon>
    </div>
  }

  @if (!isLoading) {
    <div class="d-flex align-items-center justify-content-center audio-record__controls">
      @switch (status) {
        @case (statuses.INIT) {
          <button color="primary" class="audio-record__start-btn" mat-fab (click)="startRecording()" [disabled]="!deviceReady">
            <mat-icon>circle</mat-icon>
          </button>
          @if (canUpload) {
            <input #fileInput type="file" class="d-none" accept="audio/*" (change)="fileUploaded($event)">
            <button class="audio-record__dark-btn" mat-fab (click)="fileInput.click()">
              <mat-icon svgIcon="lms-upload-file"></mat-icon>
            </button>
          }
        }
        @case (statuses.RECORDING) {
          <button color="primary" class="audio-record__start-btn" mat-fab (click)="stopRecording()" [disabled]="!deviceReady">
            <mat-icon>stop</mat-icon>
          </button>
        }
        @case (statuses.CONVERTING) {
          <mat-spinner color="primary" [diameter]="64"></mat-spinner>
        }
        @default {
          <button class="audio-record__dark-btn" mat-fab (click)="resetPlayer()">
            <mat-icon>delete</mat-icon>
          </button>
        }
      }
    </div>
  }

  @if (isLoading) {
    <div class="d-flex align-items-center justify-content-center mt-5">
      <mat-spinner diameter="64"></mat-spinner>
    </div>
  }

  @if (showMaxLengthMessage) {
    <div class="audio-record__max-duration d-flex align-items-center justify-content-center">
      <span>{{'MANUAL_ASSIGNMENT.max_duration' | translate }}: {{audioMaxLength | secondsToTime}}</span>
    </div>
  }
</div>
